import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-8">
      <div className="container mx-auto px-6 text-center">
        <p>© 2025 XiaoHongShu Lingo. All rights reserved.</p>
        <p className="mt-2">Made with ❤️ for the international Xiaohongshu community</p>
      </div>
    </footer>
  );
};

export default Footer;